import { createFeatureSelector, createSelector } from "@ngrx/store";
import { StammdatenStore } from "../../model/stammdaten.model";

export const selectStammdatenStore = createFeatureSelector<StammdatenStore>('stammdatenStore');

export const selectStammdatenIsLoading = createSelector(selectStammdatenStore, (stammdatenStore) => stammdatenStore.isLoading);

export const selectStammdatenData = createSelector(selectStammdatenStore, (stammdatenStore) => stammdatenStore.stammdaten);